import { Typography } from "@material-ui/core";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Log } from "../../../../../types/Logs";

export default function BenefitRemovedFromGroup(props: Partial<Log>) {
  const { doneByName, employeeGroup, benefitPlan } = props;
  const { t } = useTranslation();

  return useMemo(() => {
    return (
      <>
        {t("log.removed_benefit_plan_from_group")
          .split(" ")
          ?.map((text) => {
            switch (text) {
              case "{benefitName}":
                return (
                  <Typography
                    variant="subtitle2"
                    key={`logText-${Math.random() * 1000}`}
                  >
                    {`${benefitPlan} `}
                  </Typography>
                );
              case "{group}":
                return (
                  <Typography
                    variant="subtitle2"
                    key={`logText-${Math.random() * 1000}`}
                  >
                    {`${employeeGroup} `}
                  </Typography>
                );
              case "{employee}":
                return (
                  <Typography
                    variant="subtitle2"
                    key={`logText-${Math.random() * 1000}`}
                  >{`${doneByName} `}</Typography>
                );
              default:
                return `${text} `;
            }
          })}
      </>
    );
  }, [benefitPlan, doneByName, employeeGroup, t]);
}
